/* eslint-disable */
import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_API + '/excursion/activity-duration-type/';


const state = {
    activityDurationTypes: []
}

const actions = {
    async retrieveActivityDurationTypes({
        commit,
        dispatch
    }, payload) {
        // retrieve activity duration types list from bus application database        
        return axios
            .get(
                baseUrl
            )
            .then(response => {
                commit('SET_ACTIVITY_DURATION_TYPES', response.data)
                return response.data
            })
    },
    async createActivityDurationType({
        commit, dispatch
    }, payload) {
        // check whether guide_price has "," instead of "." and in this case, replace
        if ( payload.payload.guide_rate.includes(",") ) {
            payload.payload.guide_rate = payload.payload.guide_rate.replace(',', '.')
        }
        await axios
            .post(baseUrl, payload.payload)
            .then( response => {
                dispatch('retrieveActivityDurationTypes')
                return response.data
            })
            .catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Duración NO guardada",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            })
    },
    async updateActivityDurationType({
        commit, dispatch
    }, payload) {
        // check whether guide_price has "," instead of "." and in this case, replace
        if ( payload.payload.guide_rate.includes(",") ) {
            payload.payload.guide_rate = payload.payload.guide_rate.replace(',', '.')
        }
        await axios
            .patch(baseUrl + payload.item_id + '/', payload.payload)
            .then( response =>  {
                dispatch('retrieveActivityDurationTypes')
                return response.data
            })
            .catch( error => {
                this._vm.$notify({
                    group: "foo",
                    title: "Duración NO editada",
                    text: error + ' ' + JSON.stringify(error.response.data),
                    type: "error",
                });
                throw new Error(error) 
            })
    },
    async deleteActivityDurationType({
        commit, dispatch
    }, payload) {
        return axios.delete(baseUrl + payload.item_id + '/')
    }
}

const mutations = {
    SET_ACTIVITY_DURATION_TYPES(state, durations) {
        state.activityDurationTypes = durations
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}